import { shortUuid } from '../../../../../utils';
import { MediaKind, MediaMetadata, MediaSource } from './types';

export function serializeMediaMetadata({ source, ...data }: Omit<MediaMetadata, 'shortId'>) {
  return `${shortUuid()}|${source}|${btoa(JSON.stringify(data))}`;
}

export function deserializeMediaMetadata(name: string, kind: MediaKind): MediaMetadata {
  // This will happen on the React Native mobile app where we don't have the ability
  // to set a custom track name. In this case, we'll just return a default
  // source based on the track kind.
  if (!name?.includes('|')) {
    return {
      source: kind === 'video' ? MediaSource.Camera : MediaSource.Microphone,
    };
  }

  const [shortId, source, rawData] = name.split('|');
  return {
    shortId,
    source: source as MediaSource,
    ...(rawData ? JSON.parse(atob(rawData)) : {}),
  };
}
